export default {
  LIST(state, data) {
    state.directions = data
  },
  UPDATE(state, value) {
    state.direction = {
      ...value,
      category_subject: value.category_subject?.id ?? value.category_subject,
      is_priority: Boolean(value.is_priority),
    }
  },
  FRESH(state) {
    state.direction = {
      id: null,
      name: {
        uz: '',
        ru: '',
        en: '',
      },
      code: '',
      category_subject: null,
      is_priority: false,
    }
  },
  GET(state, data) {
    state.direction = data
  },
}
